    export const MANUFACTURER_CREATE_EDIT_OPEN_MODAL = "MANUFACTURER_CREATE_EDIT_OPEN_MODAL";
    export const MANUFACTURER_CREATE_REQUEST = "MANUFACTURER_CREATE_REQUEST";
    export const MANUFACTURER_CREATE_RESULT = "MANUFACTURER_CREATE_RESULT";
    export const MANUFACTURER_EDIT_REQUEST = "MANUFACTURER_EDIT_REQUEST";
    export const MANUFACTURER_EDIT_RESULT = "MANUFACTURER_EDIT_RESULT";
    export const MANUFACTURER_GET_REQUEST = "MANUFACTURER_GET_REQUEST";
    export const MANUFACTURER_GET_RESULT = "MANUFACTURER_GET_RESULT";